require('../scss/app.scss')
require.context('../img',false, /\.(png|jpe?g|gif)$/)
console.log("%c Made with ❤️ by https://buzznative.com/", 'background: #f1f1f1; color: #fe5000; padding:10px');

/* -------------------
** Librairies
** -------------------*/
// import Flickity from 'flickity'
// import { gsap } from "gsap/all"
// import { ScrollTrigger } from "gsap/ScrollTrigger"
// gsap.registerPlugin(ScrollTrigger)



/* -------------------
** Composants
** -------------------*/
// import Galerie from './composants/galerie'
import Facade from './composants/facade'
import Slider from './composants/slider'
// import Accordeon from './composants/accordeon'

window.addEventListener('DOMContentLoaded', () => {
	//Initialisation de tarteaucitron
	tarteaucitron.init({

		"privacyUrl": "", /* Privacy policy url */
		"bodyPosition": "bottom", /* or top to bring it as first element for accessibility */

		"hashtag": "#tarteaucitron", /* Open the panel with this hashtag */
		"cookieName": "tarteaucitron", /* Cookie name */
  
		"orientation": "bottom", /* Banner position (top - bottom) */
	 
		"groupServices": false, /* Group services by category */
		"showDetailsOnClick": false, /* Click to expand the description */
		"serviceDefaultState": false, /* Default state (true - wait - false) */
						 
		"showAlertSmall": false, /* Show the small banner on bottom right */
		"cookieslist": false, /* Show the cookie list */
						 
		"closePopup": false, /* Show a close X on the banner */

		"showIcon": true, /* Show cookie icon to manage cookies */
		//"iconSrc": "", /* Optionnal: URL or base64 encoded image */
		"iconPosition": "BottomLeft", /* BottomRight, BottomLeft, TopRight and TopLeft */

		"adblocker": false, /* Show a Warning if an adblocker is detected */
						 
		"DenyAllCta" : true, /* Show the deny all button */
		"AcceptAllCta" : true, /* Show the accept all button when highPrivacy on */
		"highPrivacy": true, /* HIGHLY RECOMMANDED Disable auto consent */
						 
		"handleBrowserDNTRequest": false, /* If Do Not Track == 1, disallow all */

		"removeCredit": true, /* Remove credit link */
		"moreInfoLink": false, /* Show more info link */

		"useExternalCss": false, /* If false, the tarteaucitron.css file will be loaded */
		"useExternalJs": false, /* If false, the tarteaucitron.js file will be loaded */

		//"cookieDomain": ".my-multisite-domaine.fr", /* Shared cookie for multisite */
						
		"readmoreLink": "", /* Change the default readmore link */

		"mandatory": true, /* Show a message about mandatory cookies */
		"mandatoryCta": true, /* Show the disabled accept button when mandatory on */
  
		//"customCloserId": "", /* Optional a11y: Custom element ID used to open the panel */
		
		"googleConsentMode": false, /* Enable Google Consent Mode v2 for Google ads and GA4 */
		
		"partnersList": false /* Show the number of partners on the popup/middle banner */
	});
	tarteaucitron.user.gtagUa = 'G-1HQ66KNE0M';
	(tarteaucitron.job = tarteaucitron.job || []).push('vimeo');
	(tarteaucitron.job = tarteaucitron.job || []).push('youtube');
	(tarteaucitron.job = tarteaucitron.job || []).push('gtag');
});

window.addEventListener('load', () => {

	/* -------------------
	** Mise en place des constantes
	** -------------------*/
	const coreUrl = phpVar.templateUrl;
	let viewportWidth = window.innerWidth;
	// let viewportHeight = window.innerHeight;

	/* -------------------
	** Gestion affichage fenêtre des cookies avec tarteaucitron
	** -------------------*/
	const cookievideos = document.querySelectorAll('.video');
	cookievideos.forEach((video) => {
		video.addEventListener('click', (e) => {
			if(e.target && e.target.classList.contains('tarteaucitronAllow')){
				
				document.getElementById('tarteaucitronBack').style.display="block"
				document.getElementById('tarteaucitronBack').style.opacity=.7
		
				document.getElementById('tarteaucitron').style.display="block"
				document.getElementById('tarteaucitron').style.opacity=1
			}
			
		})
	})


	/*
	**	Activation des composants en fonction des blocs
	*/
	// let galerieList = document.querySelectorAll('.galerie');
	// galerieList.forEach((galerie) => {
	// 	new Galerie(galerie);
	// });


	let facadeList = document.querySelectorAll('.video--facade');
	facadeList.forEach((facade) => {
		new Facade(facade);
	});

	let sliderList = document.querySelectorAll('.slider');
	sliderList.forEach((slider) => {
		new Slider(slider, viewportWidth);
	});

	// let accordeonList = document.querySelectorAll('.accordeon__entete');
	// accordeonList.forEach((accordeon) => {
	// 	new Accordeon(accordeon);
	// })



	// Animations des labels sur les formulaires ninja form
	let formNinja = document.querySelectorAll('.nf-field-container');
	if(formNinja.length > 0){
		formNinja.forEach((form)=> {
			let input = form.querySelector('input') ? form.querySelector('input') : form.querySelector('textarea');
			let label = form.querySelector('.nf-field-label');
			if(input) {
				let base = input.tagName === 'TEXTAREA' ? '30px' : '50%';
	
				input.addEventListener('click', () => {
					input.focus();
				})

				input.addEventListener('focusin', () => {
					label.style.top = '0px';
					console.log('test');
				});

				input.addEventListener('focusout', () => {
					if(input.value === "") {
						label.style.top = base;
					}
				})
			}
		})
	}

	let taxHeader = document.querySelector('body.tax-famille .bloc--hero') ? document.querySelector('body.tax-famille .bloc--hero') : document.querySelector('body.page-id-6 .bloc--hero');
	let contactButton = document.querySelector('.menu-bar .contact');
	if (!taxHeader) {
		taxHeader = document.querySelector('body.single-variete .bloc--hero');
	}
	if(taxHeader) {
		let flag = false;
		let checkScroll = function() {
			if(window.scrollY > 0 && flag === false) {
				taxHeader.classList.add('scrolled');
				flag = true;
				if(viewportWidth > 768) {
					let container = taxHeader.querySelector('.wrapper');
					contactButton.classList.add('btn--reverse')
					container.append(contactButton);
				}
			} else if (window.scrollY === 0 && flag === true) {
				taxHeader.classList.remove('scrolled');
				taxHeader.classList.add('unscrolled');
				if(viewportWidth > 768) {
					let container = document.querySelector('.menu-bar .container > div > div');
					contactButton.classList.remove('btn--reverse')
					container.append(contactButton);
				}
				setTimeout(function(){
					taxHeader.classList.remove('unscrolled');
				}, 500);
				flag = false;
			}
		}
		window.addEventListener('scroll', checkScroll);
		checkScroll();
	}

	

	// Animations du menu des variétés en desktop
	let menuBar = document.querySelector('.menu-bar');
	let menuWrapper = document.querySelector('.menu-bar__main');
	let menuVarietes = document.querySelector('.menu-bar__variete');
	let boutonVarietes = document.querySelector('.menu-bar .menu-item[data-id="6"]');
	let ulVarietes = document.getElementById('menu-menu-des-varietes');
	let body = document.querySelector('body');


	const faviconEl = document.querySelector('link[rel="shortcut icon"]')

	if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
		faviconEl.setAttribute('href', coreUrl + '/favicon2.png')
	}

	let mediaBlock = document.querySelectorAll('.bloc--media');
	if(viewportWidth < 767 && mediaBlock.length > 0){
		mediaBlock.forEach((media) => {
			let ancestor = media.closest('.col-md-dispo');
			if(ancestor){
				ancestor.classList.add('ordered');
			}
		})
	}

	let roundedBlock = document.querySelectorAll('.bloc--rounded');
	if(roundedBlock.length > 0){
		roundedBlock.forEach((bloc) => {
			let next = bloc.nextElementSibling;
			if(next && next.classList.contains('bloc--rounded')){
				bloc.classList.add('fix-round');
			}
		})
	}
	
	if(viewportWidth > 1300) {

		let barMain = menuWrapper.querySelectorAll(':scope > ul >li.menu-item-has-children');
		if(barMain.length > 0) {
			barMain.forEach((item) => {
				item.addEventListener('mouseenter', () => {
					item.classList.add('active');
				})

				item.addEventListener('mouseleave', () => {
					item.classList.remove('active');
				})
			})
		}
		
		let barVarietes = menuVarietes.querySelectorAll(':scope > ul > li.menu-item-has-children');

		if(barVarietes.length > 0) {
			barVarietes.forEach((item) => {
				item.addEventListener('mouseenter', () => {

					if (!body.classList.contains('tax-famille') && !body.classList.contains('home') && !body.classList.contains('page-id-6') && !body.classList.contains('single-variete')) {
						menuVarietes.classList.add('active');
					} else {
						menuBar.classList.add('active');
					}
				})

				item.addEventListener('mouseleave', () => {
					if (!body.classList.contains('tax-famille') && !body.classList.contains('home') && !body.classList.contains('page-id-6') && !body.classList.contains('single-variete')) {
						menuVarietes.classList.remove('active');
					} else {
						menuBar.classList.remove('active');
					}
				})
			})
		}

		if (!body.classList.contains('tax-famille') && !body.classList.contains('home') && !body.classList.contains('page-id-6') && !body.classList.contains('single-variete')) {
			let allowedBouton = menuVarietes.querySelectorAll(':scope > ul > li > a');
			let allowedList = [menuBar, ulVarietes, boutonVarietes];
			allowedBouton.forEach((element) => {
				allowedList.push(element);
			});
		
			if(menuVarietes) {
				menuVarietes.addEventListener('mouseleave', () => {
					menuVarietes.style.display = "none";
					menuBar.classList.remove('active');
					boutonVarietes.classList.remove('menu-active');
				})
			}
		
			if(boutonVarietes && menuVarietes) {
				boutonVarietes.addEventListener('mouseenter', () => {
					menuVarietes.style.display = "block";
					menuBar.classList.add('active');
					boutonVarietes.classList.add('menu-active');
				})
		
				boutonVarietes.addEventListener('mouseleave', (e) => {
					if(allowedList.indexOf( e.relatedTarget ) <= -1) {
						menuVarietes.style.display = "none";
						menuBar.classList.remove('active');
						boutonVarietes.classList.remove('menu-active');
					}
				})
			}
		}
	
	
		if(menuVarietes) {
			let familles = menuVarietes.querySelectorAll('[data-depth="0"]');
			if(familles.length > 0) {
				familles.forEach((famille) => {
					if(famille.classList.contains('menu-item-has-children')) {
						let subMenu = famille.querySelector(":scope >div");
						let lien = famille.querySelector(":scope >a")
						famille.addEventListener('mouseenter', ()=> {
							lien.classList.add('active');
							let size = lien.getBoundingClientRect();
							subMenu.style.top = (size.y + size.height) + 'px';
							subMenu.classList.add('active');
							let eventHandler = function() {
								lien.classList.remove('active');
								subMenu.classList.remove('active');
								window.removeEventListener('scroll', eventHandler);
							}
							window.addEventListener('scroll', eventHandler);
						})
	
						famille.addEventListener('mouseleave', () => {
							lien.classList.remove('active');
							subMenu.classList.remove('active');
						})
					}
				})
			}
		}
	} else {
		

		let allMenus = [];
		let burgerMenu = document.querySelector('.menu-burger');
		

		let contactBouton = document.querySelector('.menu-bar .contact');
		let listWrapper = document.createElement('li');

		let menuMain = document.querySelector('.menu-bar__main > ul');

		let barMain = menuWrapper.querySelectorAll(':scope > ul >li.menu-item-has-children>div>.more-arrow');
		if(barMain.length > 0) {
			barMain.forEach((item) => {
				item.addEventListener('click', () => {
					let parentWrap = item.parentElement.parentElement;
					parentWrap.classList.toggle('submenu-active');
				})
			})
		}

		boutonVarietes.append(menuVarietes);
		menuVarietes.style.display = 'block';

		listWrapper.append(contactBouton);
		menuMain.append(listWrapper);




		let links = menuVarietes.querySelectorAll('a');
		if(links.length > 0) {
			links.forEach((link) => {
				let url = link.getAttribute('href');
				let child = link.parentElement.querySelector(':scope > div:not(.famille-logo)');
				if(!link.classList.contains('archive-link') && child) {
					link.addEventListener('click', (e)=> {
						e.preventDefault();
						let subMenu = link.nextElementSibling;
						if(subMenu) {
							allMenus.push(subMenu);
							if(burgerMenu.classList.contains('white-1')) {
								burgerMenu.classList.add('white-2');
							}
							burgerMenu.classList.add('white-1');
							
							subMenu.style.transform = 'translate3D(0,0,0)';
						}
					})
				}

			})
		}

		let retours = menuVarietes.querySelectorAll('.bouton-retour');
		if(retours.length > 0) {
			retours.forEach((retour) => {
				retour.addEventListener('click', () => {
					if(burgerMenu.classList.contains('white-2')) {
						burgerMenu.classList.remove('white-2');
					} else {
						burgerMenu.classList.remove('white-1');
					}
					retour.parentElement.parentElement.style.transform = 'translate3D(100%,0,0)';
				})
			})
		}

		burgerMenu.addEventListener('click', () => {
			if(burgerMenu.classList.contains('active') && allMenus.length > 0) {
				console.log(allMenus);
				allMenus.forEach((menu) => {
					menu.style.transform = 'translate3D(100%,0,0)';
				})
				burgerMenu.classList.remove('white-1');
				burgerMenu.classList.remove('white-2');
			}
			burgerMenu.classList.toggle('active');
			menuWrapper.classList.toggle('active');
			body.classList.toggle('no-scroll');
		});


		let termRetour = document.querySelector('.famille-enfant .filter > a');
		if(termRetour) {
			let hero = document.querySelector('.contenu--taxo');
			hero.prepend(termRetour);
		}
	}
});
window.addEventListener('DOMContentLoaded', () => {
    const button = document.querySelector('#toggle-filters');
    const gridFilter = document.querySelector('.filter');
	const filterClose = document.querySelector('.filter-close');

	if(button) {
		button.addEventListener('click', function() {
			gridFilter.classList.toggle('show');
		});
	}

	if(filterClose) {
		filterClose.addEventListener('click', function() {
			gridFilter.classList.toggle('show');
		});
	}
}); 

document.addEventListener('DOMContentLoaded', function() {
    const parentContainer = document.querySelector('.grid-filter');

	if(parentContainer) {
		parentContainer.addEventListener('click', function(event) {
			if (event.target.matches('.wpgb-facet-title')) {
				event.target.classList.toggle('active');
	
				const content = event.target.nextElementSibling;
	
				content.classList.toggle('show');
			}
		});
	}
});